import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/root";
import { AmpStatusState} from "../../redux/reducers/getAmpStatusReducer/ampStatusReducer";
import { UpdateAmpStatusState } from "../../redux/reducers/getAmpStatusReducer/updateAmpStatusReducer";
import { getAmpStatus } from "../../redux/actions/ampStatus/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";import './StatusBar.css'

function StatusBar(){
    const dispatch = useDispatch()
    const ampStatusState = useSelector((state: RootState) => state.ampStatusReducer.ampStatus as AmpStatusState)
    const updateAmpStatusState = useSelector((state: RootState) => state.ampStatusReducer.updateAmpStatus as UpdateAmpStatusState)

    const message = ampStatusState.message
    const [isClosed, setIsClosed] = useState(false);

    useEffect(() => { //getting the status data
        if (!updateAmpStatusState.loading) {
            dispatch(getAmpStatus())
            const shouldAlreadyBeClosed = (localStorage.getItem("statusClosed") as string) === "1" 
            setIsClosed(shouldAlreadyBeClosed);
        }
    }, [updateAmpStatusState, dispatch])

    const handleClose = () => {
        setIsClosed(true);
        localStorage.setItem("statusClosed", "1");
    }

    if (message === ""){
        return null;
    }

    return (
        <>

           <div className={`status-bar ${isClosed ? 'closed' : ''}`}>
               <div className="status-bar-message">
                    <p>{message}</p>
               </div>
               <div className="close-button">
                    <button className="icon-button" onClick={handleClose}><FontAwesomeIcon icon={faXmark}/></button>
               </div>
            </div> 
            
        </>
    );

}
export default StatusBar;



